import CryptoJS from 'crypto-js';

export class CryptoUtil {
  // AES加密密钥
  static AES_KEY = 'jz+GKqSdoEs/pw/uIWgdkQ==';

  /**
   * AES/ECB/PKCS5Padding 加密
   * @param {string} plainText 待加密的明文
   * @returns {string} 加密后的Base64 URL编码字符串
   */
  static encryptAES(plainText) {
    try {
      // 将Base64密钥转换为WordArray
      const key = CryptoJS.enc.Base64.parse(this.AES_KEY);

      // 使用AES ECB模式加密，PKCS7Padding（等同于PKCS5Padding）
      const encrypted = CryptoJS.AES.encrypt(plainText, key, {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7,
      });

      // 获取加密后的Base64字符串
      const encryptedBase64 = encrypted.toString();

      // 转换为URL安全的Base64编码
      const urlSafeBase64 = this.toUrlSafeBase64(encryptedBase64);

      return urlSafeBase64;
    } catch (error) {
      console.error('AES加密失败:', error);
      throw new Error('加密失败');
    }
  }

  /**
   * AES/ECB/PKCS5Padding 解密
   * @param {string} encryptedText 加密后的Base64 URL编码字符串
   * @returns {string} 解密后的明文
   */
  static decryptAES(encryptedText) {
    try {
      // 将URL安全的Base64转换为标准Base64
      const standardBase64 = this.fromUrlSafeBase64(encryptedText);

      // 将Base64密钥转换为WordArray
      const key = CryptoJS.enc.Base64.parse(this.AES_KEY);

      // 解密
      const decrypted = CryptoJS.AES.decrypt(standardBase64, key, {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7,
      });

      // 转换为UTF-8字符串
      const plainText = decrypted.toString(CryptoJS.enc.Utf8);

      if (!plainText) {
        throw new Error('解密结果为空');
      }

      return plainText;
    } catch (error) {
      console.error('AES解密失败:', error);
      throw new Error('解密失败');
    }
  }

  /**
   * 将标准Base64转换为URL安全的Base64
   * @param {string} base64 标准Base64字符串
   * @returns {string} URL安全的Base64字符串
   */
  static toUrlSafeBase64(base64) {
    return base64.replace(/\+/g, '-').replace(/\//g, '_');
  }

  /**
   * 将URL安全的Base64转换为标准Base64
   * @param {string} urlSafeBase64 URL安全的Base64字符串
   * @returns {string} 标准Base64字符串
   */
  static fromUrlSafeBase64(urlSafeBase64) {
    let base64 = urlSafeBase64.replace(/-/g, '+').replace(/_/g, '/');

    // 补充缺失的填充字符
    const padding = base64.length % 4;
    if (padding) {
      base64 += '='.repeat(4 - padding);
    }

    return base64;
  }
}

// 导出默认实例方法
export default {
  encryptAES: CryptoUtil.encryptAES.bind(CryptoUtil),
  decryptAES: CryptoUtil.decryptAES.bind(CryptoUtil),
};
